import { FieldError } from '@estee/elc-inputs';
import { Dropdown } from '@estee/elc-dropdown';
import { observer } from 'mobx-react';

import * as React from 'react';
import { IFieldProps } from './Field';

export interface IOptionItem {
    label: string;
    value: string;
}
export interface IDropDownProps {
    inputLabel: string;
    isRequired: boolean;
    dataTestId: string;
    customClassName?: string;
    hasError?: boolean;
    isDisabled?: boolean;
    options: IOptionItem[];
    isFilterable?: boolean;
    isOpenByDefault?: boolean;
    searchAhead?: boolean;
    useDropup?: boolean;
    withFloatingLabel?: boolean;
    withNameInAriaLabel?: boolean;
    dropdownDataTestId?: string;
    autoComplete?: string;
    onChange?(inputName: string, val: string): void;
}

export const FormDropDown = observer((props: IDropDownProps & IFieldProps) => {
    const {
        form,
        field,
        inputLabel,
        customClassName,
        isRequired,
        dataTestId,
        options,
        isDisabled,
        isFilterable,
        withFloatingLabel,
        withNameInAriaLabel,
        dropdownDataTestId,
        searchAhead,
        autoComplete
    } = props;
    const errorMessage = form.getError(field.name);
    const value = form.values[field.name];

    // Takes the posibility of having extra onChange logic
    const composedOnChange = (fieldName: string, newValue: string) => {
        field.onDropDownChange(fieldName, newValue);

        if (props.onChange) {
            props.onChange(fieldName, newValue);
        }
    };

    return (
        <div>
            <Dropdown
                name={field.name}
                selectedValue={value}
                hasError={Boolean(errorMessage) || props.hasError}
                withFloatingLabel={withFloatingLabel}
                withNameInAriaLabel={withNameInAriaLabel}
                dropdownDataTestId={dropdownDataTestId}
                searchAhead={searchAhead}
                placeholder={inputLabel}
                className={customClassName}
                isRequired={isRequired}
                onChange={composedOnChange}
                dataTestId={dataTestId}
                isFilterable={isFilterable}
                isDisabled={isDisabled}
                options={options}
                autoComplete={autoComplete}
            />
            <FieldError errorMessage={errorMessage} />
        </div>
    );
});
